import app from '@/app.js'

const state = {
    groups: [],
    bins: [],
    reports: [],
    errors: [],
    ekeys: [],
    errors_loc: [],
    frames: []
}

const getters = {
    ekeys: state => {
        return state.ekeys == null ? [] : state.ekeys;
    },
    ekeysfilt: state => {
        return (pattern) => {
            if (state.ekeys == null) return [];
            if (!pattern) return state.ekeys;
            return state.ekeys.filter(e => {
                return new RegExp("^_" + pattern + "\\d*", "i").test(e)
            })
        };
    },
    errors: state => {
        return state.errors == null ? {} : state.errors;
    },
    isExists: (state) => {
        return (id) => {
            if (state.errors == null) return false;
            return state.errors["_" + id];
        };
    },
    error: (state) => {
        return (id) => {
            if (state.errors == null) return {};
            return !state.errors[id] ? {} : state.errors[id];
        };
    },
    errors_loc: state => {
        return state.errors_loc == null ? [] : state.errors_loc;
    },
    groups: state => {
        return state.groups == null ? [] : state.groups;
    },
    bins: state => {
        return state.bins == null ? [] : state.bins;
    },
    frames: state => {
        return state.frames == null ? [] : state.frames;
    },
    reports: state => {
        return state.reports == null ? [] : state.reports;
    },
    msgById: (state) => {
        return (i, l) => {
            try {
                //console.log(i, l);
                if (!state.errors) return i.name_id;
                let e = state.errors["_" + i.name_id];
                //console.log(e);
                l = l.toLowerCase();
                //console.log(e[l]);
                if (e[l]) return e[l];
                //console.log(e['g_' + l]);
                if (e['g_' + l]) return e['g_' + l];
                //console.log(e['en']);
                if (e['en']) return e['en'];
                if (e['g_en']) return e['g_en'];
            } catch (e) { return i.name_id; }
            return i.name_id;
        }
    },
}
const actions = {
    LOAD: (context) => {
        if (context.getters.isReports) return;
        app.getAdminInfo()
            .then(response => {
                context.commit("set_data", response);
            })
            .catch(error => {
                console.error(error);
            });

    },
    DEL_REPORT: (context, id) => {
        app
            .erase(id, "ReportRecord")
            .then(() => {
                context.commit("remove_report", id);
            })

    },
    DEL_USER: (context, item) => {
        app
            .erase(item.id, "UserRecord")
            .then(() => {
                context.commit("remove_user", item);
            })
    },
    INSERT_FRAME: (context, item) => {
        app.insertFrame(item).then(response => {
            if (response.count) {
                context.commit("insert_frame", item);
            }
        })
    },
    UPDATE_FRAME: (context, item) => {
        app.updateFrame(item).then(response => {
            if (response.count) {
                context.commit("update_frame", item);
            }
        })
    },
    DELETE_FRAME: (context, item) => {
        app.deleteFrame(item).then(response => {
            console.log(response);
            context.commit("delete_frame", item);
            if (response.count) {
                context.commit("delete_frame", item);
            }
        }).catch(error => {
            console.log(error);
        })
    },
    LOAD_ERROR: async (context) => {
        context.state.errors_loc = [];
        context.state.errors = {};
        try {
            let response = await app.getErrors(false);
            context.commit("add_errors", {
                items: response,
                isGlobal: false
            });
            response = await app.getErrors(true);
            context.commit("add_errors", {
                items: response,
                isGlobal: true
            });
        } catch (e) {
            console.log(e.message);
        }
    },
    SAVE_ERROR: (context, params) => {
        app.updateMsg(params).then(response => {
            if (response.count) {
                context.commit(params.add ? "insert_message" : "update_message", {
                    id: params.id,
                    rec: params.record,
                    list: params.newrecs
                });
            }
        })
    },

}

const mutations = {
    clean: (state) => {
        state.groups = [];
        state.bins = [];
        state.reports = [];
        state.errors = [];
        state.ekeys = [];
        state.errors_loc = [];

    },
    remove_report: (state, payload) => {
        state.reports = state.reports.filter(function (el) {
            return el.id != payload;
        })
    },
    insert_frame: (state, payload) => {
        state.frames.push({ ...payload, IDX: state.frames.length + 1 });
    },
    delete_frame: (state, payload) => {
        state.frames.find((o, i) => { if (o && o.hashid == payload) state.frames.splice(i, 1); });
    },
    update_frame: (state, payload) => {
        state.frames.find((o, i) => {
            if (o && o.hashid == payload.hashid) {
                state.frames.splice(i, 1, { ...payload });
            }
        });
    },
    insert_report: (state, payload) => {
        state.reports.push(payload);
    },
    remove_message: (state, payload) => {
        try {
            delete state.errors["_" + payload.id][payload.loc];
            state.ekeys = Object.keys(state.errors).sort();
        } catch (e) {
            console.error(e);
        }
    },
    update_message: (state, payload) => {
        try {
            state.errors["_" + payload.id] = payload.rec;
            payload.list.forEach(e => {
                state.errors["_" + payload.id][(e.glob ? "g_" : "") + e.loc] = e.msg;
            });
            state.ekeys = Object.keys(state.errors).sort();
        } catch (e) {
            console.error(e);
        }
    },
    insert_message: (state, payload) => {
        try {
            // let id = "_" + payload.id;
            // if (!state.errors[id]) state.errors[id] = payload;
            console.log(payload);
            state.errors["_" + payload.id] = payload.rec;
            payload.list.forEach(e => {
                state.errors["_" + payload.id][(e.glob ? "g_" : "") + e.loc] = e.msg;
            });
            state.ekeys = Object.keys(state.errors).sort();
        } catch (e) {
            console.error(e);
        }
    },
    remove_group: (state, payload) => {
        state.groups = state.groups.filter(function (value) { return value.id != payload.id; })
    },
    insert_group: (state, payload) => {
        state.groups.push(payload);
    },
    update_group: (state, payload) => {
        state.groups.forEach(e => {
            if (e.id == payload.id) {
                e = payload;
            }
        })
    },
    insert_user: (state, payload) => {
        try {
            state.groups.forEach(e => {
                if (e.id == payload.userGroup) {
                    if (!e.children) e.children = [];
                    e.children.push(payload.id);
                }
            })
        } catch (e) {
            console.log(e.message);
        }
    },
    remove_user: (state, payload) => {
        try {
            state.groups.forEach(e => {
                if (e.id == payload.userGroup) {
                    let i = e.children.indexOf(payload.id);
                    if (i != -1) {
                        e.children.splice(i, 1);
                    }
                    e.children = [...e.children];
                }
            })
        } catch (e) {
            console.log(e.message);
        }
    },
    set_data: (state, payload) => {
        try {
            state.groups = payload.groups;
            payload.users.forEach(u => {
                try {
                    for (var i = 0; i < state.groups.length; i++) {
                        if (state.groups[i].id.trim().toLowerCase() == u.user_group.trim().toLowerCase()) {
                            if (!state.groups[i].children) state.groups[i].children = [];
                            state.groups[i].children.push({ name: u.id.toLowerCase(), status: u.status });
                            break;
                        }
                    }
                } catch (e) {
                    console.error(e);
                }
            })
            state.reports = payload.reports;
            state.bins = payload.bins;
            state.frames = payload.frames;
        } catch (e) {
            console.error(e);
        }
    },
    add_errors: (state, payload) => {
        payload.items.forEach(e => {
            let id = "_" + e.errorId;
            let loc = (payload.isGlobal ? "g_" : "") + e.lang.toLowerCase();
            if (state.errors_loc.indexOf(loc) == -1) state.errors_loc.push(loc);
            if (!state.errors[id]) state.errors[id] = {};
            state.errors[id][loc] = e.message;
        });
        state.ekeys = Object.keys(state.errors).sort();
    }
}

const Report = {
    namespaced: true,
    state: state,
    mutations: mutations,
    actions: actions,
    getters: getters
}

export default Report;